import React from 'react';
import * as C from "./styles";

const Header = () => {
  return (
    <C.Container>
      <C.Haeader>
        <C.Title>
          Controle Financeiro
        </C.Title>
      </C.Haeader>
    </C.Container>
  );
}

export default Header;